module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "transfer-dom",
      rawName: "v-transfer-dom"
    }]
  }, [_c('transition', {
    attrs: {
      "name": _vm.transitionNames[1]
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.visible),
      expression: "visible"
    }],
    class: _vm.maskClasses,
    on: {
      "click": _vm.mask
    }
  })]), _vm._v(" "), _c('div', {
    class: _vm.wrapClasses,
    on: {
      "click": _vm.handleWrapClick
    }
  }, [_c('transition', {
    attrs: {
      "name": _vm.transitionNames[0]
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.visible),
      expression: "visible"
    }],
    class: _vm.classes,
    style: (_vm.mainStyles)
  }, [_c('div', {
    class: [_vm.prefixCls + '-content']
  }, [(_vm.closable) ? _c('a', {
    class: [_vm.prefixCls + '-close'],
    on: {
      "click": _vm.close
    }
  }, [_vm._t("close", [_c('Icon', {
    attrs: {
      "type": "ios-close-empty"
    }
  })])], 2) : _vm._e(), _vm._v(" "), (_vm.showHead) ? _c('div', {
    class: [_vm.prefixCls + '-header']
  }, [_vm._t("header", [_c('div', {
    class: [_vm.prefixCls + '-header-inner']
  }, [_vm._v(_vm._s(_vm.title))])])], 2) : _vm._e(), _vm._v(" "), _c('div', {
    class: [_vm.prefixCls + '-body']
  }, [_vm._t("default")], 2), _vm._v(" "), (!_vm.footerHide) ? _c('div', {
    class: [_vm.prefixCls + '-footer']
  }, [_vm._t("footer", [_c('i-button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    nativeOn: {
      "click": function($event) {
        _vm.cancel($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.localeCancelText))]), _vm._v(" "), _c('i-button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.buttonLoading
    },
    nativeOn: {
      "click": function($event) {
        _vm.ok($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.localeOkText))])])], 2) : _vm._e()])])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-582bded1"}!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./~/iview/src/components/modal/modal.vue
// module id = 128
// module chunks = 1